// extracted by mini-css-extract-plugin
export default {"container":"paymentSuccess_container__9YTQn","successCard":"paymentSuccess_successCard__CmifT","icon":"paymentSuccess_icon__hetzg"};